<div class="flex h-[85%] flex-col">
  <app-agnostic-grids class="min-h-0! flex-auto!" [dependencies]="gridDependencies"></app-agnostic-grids>
</div>
<div class="mt-[2em] flex justify-between">
  <p-button [label]="'cancel' | translate" iconPos="left" (onClick)="hideDialog()" severity="secondary">
    <ng-template #icon>
      <fa-icon [icon]="faTimes"></fa-icon>
    </ng-template>
  </p-button>
  <p-button
    severity="success"
    iconPos="left"
    [label]="'save' | translate"
    [disabled]="isSaveDisabled()"
    (onClick)="addTemplateContent()"
  >
    <ng-template #icon>
      <fa-icon [icon]="faSave"></fa-icon>
    </ng-template>
  </p-button>
</div>
